import React from "react";
import {i18nFormat} from "../../lib/i18nFormat";
import {useOrders} from "@shared/hooks/useOrders";
import {EmptyPageContent} from "../../components/EmptyPageContent";
import {Order} from "./Order";

export function OrdersPage() {
  const [orders, isLoading] = useOrders();

  if (isLoading) {
    return null;
  }

  if (orders.length === 0) {
    return (
      <EmptyPageContent
        glyph={"glyph-core-cart-fill"}
        title={i18nFormat("orders.no-orders.title")}
        text={i18nFormat("orders.no-orders.description")}
      />
    )
  }

  return (
    <section className="account-page account-orders">
      <header className="account-page__header">
        <h1 className="account-page__title">{i18nFormat("orders.title")}</h1>
        <p className="account-page__text">{i18nFormat("orders.subtitle")}</p>
      </header>
      <div className="account-page__content">
        {orders.map(order => (
          <Order key={order.id} order={order} />
        ))}
      </div>
    </section>
  );
}